/*
 * Copyright (c) 2025.
 *  The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {SettingsResponse} from "types/responses/SettingsResponse";
import {createAction} from "helpers/createAction";
import {API_KEY} from "helpers/config";
import ajax from "helpers/ajax";

class SettingsAction {
    static readonly SET_SETTINGS = "SettingsAction.SetSettings";

    static fetchSettings = () => {
        return async (dispatch) => {
            try {
                const response: SettingsResponse = await ajax.get("/settings/public", {
                    params: {
                        api_key: API_KEY,
                    },
                });
                console.log(response);
                dispatch(SettingsAction.setSettings(response));
                return Promise.resolve(response);
            } catch (err) {
                console.log("fetchSettings - catch - response");
                return Promise.reject(err);
            }
        };
    };

    static setSettings(settings: SettingsResponse) {
        return createAction(SettingsAction.SET_SETTINGS, settings);
    }

}

export default SettingsAction;
